import { render, staticRenderFns } from "./RadiolistQuestion.vue?vue&type=template&id=535612d5&scoped=true&"
import script from "./radiolist-question.js?vue&type=script&lang=js&"
export * from "./radiolist-question.js?vue&type=script&lang=js&"
import style0 from "./radiolist-question.scss?vue&type=style&index=0&id=535612d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535612d5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('535612d5')) {
      api.createRecord('535612d5', component.options)
    } else {
      api.reload('535612d5', component.options)
    }
    module.hot.accept("./RadiolistQuestion.vue?vue&type=template&id=535612d5&scoped=true&", function () {
      api.rerender('535612d5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/AudienceManager/Components/Builder/Questions/RadiolistQuestion/RadiolistQuestion.vue"
export default component.exports